import { Component, OnInit } from '@angular/core';
import { CustomArrayModel } from '../../../shared/constants';
import { BreakDownDetailsService } from '../../../core/services/break-down-details-services';

@Component({
	selector: 'app-break-down-details',
	templateUrl: './break-down-details.component.html',
	styleUrls: ['./break-down-details.component.scss']
})
export class BreakDownDetailsComponent implements OnInit {

	details: CustomArrayModel[];
	title: string;
	submitting = false;
	error: string;
	currentIndex = 1;
	constructor(private breakDownService: BreakDownDetailsService) { }

	ngOnInit(): void {
		this.initialize();

		this.breakDownService._detailsAlert$
			.subscribe(data => {
				if (data) {
					this.details = this.breakDownService.getBreakDownDetails();
					this.currentIndex = 0;
				}
				else {
					this.error = this.breakDownService.getError();
					this.currentIndex = 2;
				}
				this.submitting = false;
			});
	}

	private initialize() {
		this.title = this.breakDownService.getTitle();
		this.details = this.breakDownService.getBreakDownDetails();
	}

	closeModal() {
		this.breakDownService.closeModal();
	}

	reloadDetails() {
		this.submitting = true;
		this.breakDownService.reloadDetails();
	}
}
